CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
CustomField = require 'app/scripts/models/custom-field'

class CustomFieldList extends CollectionWithHelpers
  model: CustomField

  initialize: ->
    @listenTo(@, 'change:pos', @sort)

  comparator: (customField) ->
    customField.get('pos')

module.exports = CustomFieldList
